import {Component} from 'react';
import h from 'react-hyperscript';
import './DonutChart.scss';
import {h4} from 'Components/Typography/Typography';
import {unMountD3} from 'Src/utils/utils';
import Image from 'Components/Image/Image';
import Benchmarking from 'Components/Benchmarking/Benchmarking';
import * as d3 from 'd3';
import {setZeroIfInvalidNumber, getPercentValue} from 'Src/utils/utils';

class DonutChart extends Component {
  constructor(props) {
    super(props);
    this.createDonutChart = this.createDonutChart.bind(this);
    this.width = this.props.size[0];
    this.height = this.props.size[1];
    this.state = {
      percentage: 0,
    };
  }

  componentDidMount() {
    this.updatePercentage();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.updatePercentage();
    }
  }

  componentWillUnmount() {
    unMountD3(this.node, d3);
  }

  updatePercentage() {
    const value = setZeroIfInvalidNumber(this.props.data[0]);
    this.setPercentage(`${getPercentValue(value)}%`);
  }

  setPercentage(value) {
    this.setState({
      percentage: value,
    }, () => {
      this.createDonutChart();
    });
  }

  createDonutChart() {
    const node = this.node;
    const radius = Math.min(this.width, this.height) / 2;

    const color = d3.scaleOrdinal([
      this.props.color,
      '#e8eaed',
    ]);

    const outerRadius = radius;
    const innerRadius = radius - 10;

    const svg = d3.select(node);

    const pie = d3.pie().sort(null);

    const backgroundArc = d3.arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .startAngle(0)
        .endAngle(Math.PI * 2);

    const arc = d3.arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .cornerRadius(outerRadius - innerRadius);

    const g = svg.append('g')
        .attr('transform', `translate(${this.width / 2}, ${this.height / 2})`);

    g.append('path')
        .attr('fill', '#e8eaed')
        .attr('class', 'background-arc')
        .attr('d', backgroundArc);

    const arcs = g.selectAll('g')
        .data(pie(this.props.data))
        .enter()
        .append('g')
        .attr('class', 'arc')
        .attr('style', (d, i) => {
          if (i === 1) {
            return 'display: none;';
          }
        });

    arcs.append('path')
        .attr('fill', (d, i) => color(0))
        .attr('d', arc);
  }

  render() {
    let classes = 'chart--donut';
    if (this.props.className) {
      classes += ` ${this.props.className}`;
    }


    const valueComponents = [
      h(Image, {
        key: 'donut__image__key',
        src: this.props.image,
        className: 'donut__image',
      }, null),
      h(h4, {
        key: 'graph-value__key',
        className: 'text--center',
      }, this.state.percentage),
    ];

    if (!isNaN(this.props.dataChange)) {
      valueComponents.push(
          h(Benchmarking, {
            change: this.props.dataChange,
          })
      );
    }

    return (
      h('div', {
        className: classes,
      },
      h('div', {
        className: 'donut__container flex--center',
      }, [
        h('svg', {
          key: `${this.props.id}__key`,
          ref: (node) => this.node = node,
          width: this.width,
          height: this.height,
        }),
        h('div', {
          className: 'donut__values',
        }, valueComponents),
      ])
      )
    );
  }
}

export default DonutChart;
